import * as elog from '@reverbdotcom/commons/dist/elog';

function trackArticleView(articleId, aid, utmCampaign) {
  const event = new elog.events.ArticleView({
    url: window.location.href,
    aid: aid || '',
    referer: document.referrer,
    utm_campaign: utmCampaign || '',
    article_id: articleId.toString(),
  });

  elog.track(event);
}

export default {
  trackArticleView,
};



// WEBPACK FOOTER //
// ./javascripts/components/event_tracking.js